// TỪ KHOÁ NHIỀU DÒNG (06/10/2026 — phác thảo của người dùng: mỗi dòng gồm "Từ khoá | Số lượng | Chuyển từ khoá tiếp sau (giờ)" + nút "Thêm từ khoá").
// Module THUẦN (không DOM, không I/O): dùng chung trang soạn kịch bản (Boss web), máy chủ (kiểm lúc lưu), runner (chọn từ khoá của lần chạy).
//
// LƯU TRỮ (tương thích ngược — không đổi nghĩa của tham số từ khoá cũ):
//  · tham số từ khoá (tu_khoa / tu_khoa_nhom) vẫn là chuỗi `a | b | c` như F-1 (chỉ các TỪ KHOÁ, theo thứ tự dòng). Từ khoá có ký tự "|" được mã hoá "%7C"
//    (xoay-tu-khoa.ts maHoaTuKhoa) nên không phá định dạng; dấu phẩy trong từ khoá giữ nguyên (dấu phân cách là "|", không phải ",").
//  · tham số MỚI `<tên>_cau_hinh` (chuỗi, tuỳ chọn): "<chế độ>;<số lượng>:<giờ>,<số lượng>:<giờ>,…" — mỗi cặp ứng với MỘT từ khoá cùng vị trí, ô trống = chưa đặt.
//    Chế độ: lan (xoay theo LẦN chạy — như F-1), gio (xoay theo THỜI GIAN: dòng hiện tại dùng hết số giờ rồi lần chạy kế sang dòng kế), tat_ca (MỖI lần chạy dùng
//    TẤT CẢ từ khoá, chia theo số lượng từng dòng). Không có tham số này = sơ đồ / bundle cũ → chế độ lan, hành vi như F-1.
//  · "Số lượng" = số mục (nhóm xin vào / bài bình luận / video…) bước làm việc sau bước Tìm xử lý cho từ khoá đó trong MỘT lần chạy.
//  · "Chuyển từ khoá tiếp sau (giờ)" = số GIỜ từ khoá này được dùng; hết khoảng đó thì lần chạy kế tiếp dùng từ khoá kế (hết danh sách quay về dòng 1).
import { dem, GIOI_HAN_XOAY, giaiMaTuKhoa, khoaSo, maHoaTuKhoa } from "./xoay-tu-khoa";
export type CheDoTuKhoa = "lan" | "gio" | "tat_ca";
export const CAC_CHE_DO: readonly CheDoTuKhoa[] = ["gio", "tat_ca", "lan"];
export const NHAN_CHE_DO: Readonly<Record<CheDoTuKhoa, string>> = {
  gio: "Xoay vòng theo thời gian (giờ)",
  tat_ca: "Dùng tất cả từ khoá mỗi lần chạy",
  lan: "Xoay vòng theo lần chạy (mỗi lần một từ khoá)",
};
export const GIAI_THICH_CHE_DO: Readonly<Record<CheDoTuKhoa, string>> = {
  gio: "Mỗi từ khoá được dùng trong số giờ ghi ở cột bên phải; hết giờ thì lần chạy kế tiếp sang từ khoá kế (hết danh sách quay lại dòng 1)",
  tat_ca: "Mỗi lần chạy tìm lần lượt TẤT CẢ từ khoá, mỗi từ khoá làm đúng số lượng đã ghi",
  lan: "Mỗi lần chạy dùng một từ khoá, lần sau sang từ khoá kế (như trước đây)",
};

export const TOI_DA_MOT_TU_KHOA = 500; // một từ khoá duy nhất: giới hạn cũ của tham số chữ (src/shared/so-do.ts GIOI_HAN_SO_DO.thamSo)
export const GIO_MAC_DINH = 24;
export const GIO_TOI_THIEU = 1;
export const GIO_TOI_DA = 720; // 30 ngày
export const SO_LUONG_TOI_THIEU = 1;
export const SO_LUONG_TOI_DA = 100; // = trần kỹ thuật "số mục mỗi lượt" (khuyen-nghi-so.ts TRAN_KY_THUAT.dem)

export interface DongTuKhoa {
  tuKhoa: string; // chữ thật (đã giải mã)
  soLuong: number | null; // null = chưa đặt
  chuyenSauGio: number | null; // null = chưa đặt (dùng GIO_MAC_DINH)
}
export interface CauHinhTuKhoa { cheDo: CheDoTuKhoa; dong: DongTuKhoa[] }

const DAU_TACH = /\r\n|[|\r\n]/;
const laSoNguyen = (s: string): boolean => /^\d{1,9}$/.test(s);

/** Tên tham số cấu hình đi kèm tham số từ khoá (tu_khoa → tu_khoa_cau_hinh, tu_khoa_nhom → tu_khoa_nhom_cau_hinh). Lần dùng thứ n ≥ 2 của khối (lan-dung.ts) mang hậu tố _n ở CUỐI cả hai tên:
 *  tu_khoa_2 → tu_khoa_cau_hinh_2, tu_khoa_nhom_3 → tu_khoa_nhom_cau_hinh_3 (khớp tên khoiLanThu đặt cho tham số cấu hình của khối). */
export const tenCauHinhTuKhoa = (tenThamSoTuKhoa: string): string => {
  const m = /^(.*?)_(\d+)$/.exec(tenThamSoTuKhoa);
  return m ? `${m[1]}_cau_hinh_${m[2]}` : `${tenThamSoTuKhoa}_cau_hinh`;
};

function laCheDo(x: unknown): x is CheDoTuKhoa { return x === "lan" || x === "gio" || x === "tat_ca"; }

/** Đọc chuỗi cấu hình (không ném). Sai định dạng → chế độ lan, không có số. Trả mảng cặp theo VỊ TRÍ (có thể ngắn hơn số từ khoá). */
export function docCauHinhChuoi(s: unknown): { cheDo: CheDoTuKhoa; cap: { soLuong: number | null; gio: number | null }[]; coCauHinh: boolean } {
  if (typeof s !== "string" || !s.trim()) return { cheDo: "lan", cap: [], coCauHinh: false };
  const i = s.indexOf(";");
  const dau = (i < 0 ? s : s.slice(0, i)).trim();
  // Chuỗi KHÔNG bắt đầu bằng một chế độ hợp lệ (người gõ tay / dữ liệu lạ) → coi như không có cấu hình (xoay theo lần chạy như cũ) — tham số này do trang soạn ghi, không phải ô nhập tay.
  if (!laCheDo(dau)) return { cheDo: "lan", cap: [], coCauHinh: false };
  const cheDo: CheDoTuKhoa = dau;
  const cap = (i < 0 ? "" : s.slice(i + 1)).split(",").filter((_, k, a) => !(a.length === 1 && a[0] === "")).map((p) => {
    const [a = "", b = ""] = p.split(":").map((x) => x.trim());
    return { soLuong: laSoNguyen(a) ? Number(a) : null, gio: laSoNguyen(b) ? Number(b) : null };
  });
  return { cheDo, cap, coCauHinh: true };
}

/**
 * Lỗi (tiếng Việt) của chuỗi cấu hình; null = hợp lệ / trống. `soTuKhoa` = số từ khoá trong tham số từ khoá đi kèm (cặp thừa là lỗi).
 * Số lượng 1–100, giờ 1–720, số nguyên; ô trống được phép (chưa đặt).
 */
export function loiCauHinhTuKhoa(s: unknown, soTuKhoa: number): string | null {
  if (s === undefined || s === null) return null;
  if (typeof s !== "string") return "cấu hình từ khoá phải là chữ";
  if (!s.trim()) return null;
  if (dem(s) > 1500) return "cấu hình từ khoá quá dài";
  const i = s.indexOf(";");
  const dau = (i < 0 ? s : s.slice(0, i)).trim();
  if (!laCheDo(dau)) return null; // không bắt đầu bằng chế độ hợp lệ → bị bỏ qua khi chạy (docCauHinhChuoi), không phải lỗi
  const cap = (i < 0 ? "" : s.slice(i + 1));
  if (!cap.trim()) return null;
  const ds = cap.split(",");
  if (ds.length > soTuKhoa) return `có ${ds.length} dòng số lượng / giờ nhưng chỉ có ${soTuKhoa} từ khoá`;
  for (const [k, p] of ds.entries()) {
    const m = /^\s*(\d*)\s*:\s*(\d*)\s*$/.exec(p);
    if (!m) return `dòng ${k + 1}: số lượng / giờ phải dạng “số:số” (hoặc để trống), đang là “${p.slice(0, 20)}”`;
    if (m[1] && (!laSoNguyen(m[1]) || Number(m[1]) < SO_LUONG_TOI_THIEU || Number(m[1]) > SO_LUONG_TOI_DA)) return `dòng ${k + 1}: số lượng phải là số nguyên ${SO_LUONG_TOI_THIEU}–${SO_LUONG_TOI_DA} (đang là ${m[1]})`;
    if (m[2] && (!laSoNguyen(m[2]) || Number(m[2]) < GIO_TOI_THIEU || Number(m[2]) > GIO_TOI_DA)) return `dòng ${k + 1}: số giờ chuyển từ khoá phải là số nguyên ${GIO_TOI_THIEU}–${GIO_TOI_DA} (đang là ${m[2]})`;
  }
  return null;
}

/**
 * Danh sách dòng từ khoá ĐẦY ĐỦ từ hai tham số (dùng ở runner và để hiện lại trong trình soạn). Cùng luật tách với tachTuKhoa (xoay-tu-khoa.ts): bỏ dòng rỗng,
 * bỏ trùng (không phân biệt hoa thường / dấu / khoảng trắng — giữ dòng ĐẦU), tối đa GIOI_HAN_XOAY.soTu; cặp số lượng/giờ đi theo VỊ TRÍ TRƯỚC khi bỏ trùng
 * (nên bỏ dòng rỗng / trùng không làm lệch cặp). `tuKhoa` không có dấu phân cách → một dòng NGUYÊN VĂN (như cũ). Không ném.
 */
export function docTuKhoaDayDu(tuKhoa: unknown, cauHinh?: unknown): CauHinhTuKhoa {
  const { cheDo, cap } = docCauHinhChuoi(cauHinh);
  if (typeof tuKhoa !== "string" || !tuKhoa.trim()) return { cheDo, dong: [] };
  if (!/[|\r\n]|%(?:7C|25)/i.test(tuKhoa)) return { cheDo, dong: [{ tuKhoa, soLuong: cap[0]?.soLuong ?? null, chuyenSauGio: cap[0]?.gio ?? null }] };
  const thay = new Set<string>();
  const dong: DongTuKhoa[] = [];
  for (const [k, p] of tuKhoa.split(DAU_TACH).entries()) {
    const t = giaiMaTuKhoa(p.trim());
    if (!t) continue;
    const key = khoaSo(t);
    if (thay.has(key)) continue;
    thay.add(key);
    dong.push({ tuKhoa: t, soLuong: cap[k]?.soLuong ?? null, chuyenSauGio: cap[k]?.gio ?? null });
    if (dong.length >= GIOI_HAN_XOAY.soTu) break;
  }
  return { cheDo, dong };
}

/**
 * CHUYỂN DÒNG → hai chuỗi lưu. Bỏ dòng từ khoá trống. Một dòng, chế độ mặc định, không số lượng / giờ → tham số cấu hình RỖNG (y như sơ đồ cũ).
 * Số lượng / giờ ngoài khoảng KHÔNG bị sửa ở đây (kiểm ở loiTuKhoaDong / máy chủ).
 */
export function chuoiTuCauHinh(c: CauHinhTuKhoa): { tuKhoa: string; cauHinh: string } {
  const dong = c.dong.map((d) => ({ ...d, tuKhoa: d.tuKhoa.replace(/[\r\n]+/g, " ").trim() })).filter((d) => d.tuKhoa);
  const coSo = dong.some((d) => d.soLuong !== null || d.chuyenSauGio !== null);
  const tuKhoa = dong.length === 1 && !/[|]|%(?:7C|25)/i.test(dong[0]!.tuKhoa) ? dong[0]!.tuKhoa : dong.map((d) => maHoaTuKhoa(d.tuKhoa)).join(" | ");
  // Không số lượng / giờ: "lan" (hoặc chỉ một từ khoá) = y như sơ đồ cũ → rỗng; nhiều dòng ở chế độ khác → chỉ ghi chế độ.
  if (!coSo) return { tuKhoa, cauHinh: dong.length <= 1 || c.cheDo === "lan" ? "" : c.cheDo };
  const cap = dong.map((d) => `${d.soLuong ?? ""}:${d.chuyenSauGio ?? ""}`);
  // bỏ cặp trống ở CUỐI cho gọn
  while (cap.length && cap[cap.length - 1] === ":") cap.pop();
  return { tuKhoa, cauHinh: `${c.cheDo}${cap.length ? ";" + cap.join(",") : ""}` };
}

/**
 * Chuỗi cũ (do người dùng gõ, "a | b | c" hoặc "a, b, c") → các dòng, để trình soạn hiện nhiều dòng khi mở lại KHÔNG mất dữ liệu.
 * `tachPhay` = cũng tách theo dấu phẩy khi chuỗi không có "|" / xuống dòng (người dùng cũ hay gõ "a, b, c"). Từ khoá có "|" đã mã hoá được giải mã.
 */
export function dongTuChuoiCu(tuKhoa: unknown, tachPhay = true): { dong: string[]; daTachPhay: boolean } {
  if (typeof tuKhoa !== "string" || !tuKhoa.trim()) return { dong: [], daTachPhay: false };
  if (/[|\r\n]|%(?:7C|25)/i.test(tuKhoa)) return { dong: tuKhoa.split(DAU_TACH).map((x) => giaiMaTuKhoa(x.trim())), daTachPhay: false };
  if (tachPhay && tuKhoa.includes(",")) {
    const ds = tuKhoa.split(",").map((x) => x.trim()).filter(Boolean);
    if (ds.length > 1) return { dong: ds, daTachPhay: true };
  }
  return { dong: [tuKhoa], daTachPhay: false };
}

// ---------------------------------------------------------------- kiểm hợp lệ (trình soạn + máy chủ) ----------------------------------------------------------------
export interface KetQuaKiemTuKhoa { loi: string[]; canhBao: string[] }
/** `soLuongKhuyen` = số mục khuyên dùng tối đa MỖI LẦN CHẠY cho việc sau bước Tìm (vd 3 nhóm mới); null = không có lời khuyên. */
export function kiemTuKhoaDong(c: CauHinhTuKhoa, tuyChon: { soLuongKhuyen?: number | null; donVi?: string } = {}): KetQuaKiemTuKhoa {
  const loi: string[] = [], canhBao: string[] = [];
  const co = c.dong.map((d, i) => ({ d, i, t: d.tuKhoa.trim() }));
  const coChu = co.filter((x) => x.t);
  const rong = co.filter((x) => !x.t);
  if (rong.length) canhBao.push(`${rong.length === 1 ? `Dòng ${rong[0]!.i + 1}` : `Các dòng ${rong.map((x) => x.i + 1).join(", ")}`} chưa có từ khoá — sẽ bị bỏ qua khi chạy`);
  if (!coChu.length) loi.push("Chưa có từ khoá nào — hãy điền ít nhất một dòng");
  if (coChu.length > GIOI_HAN_XOAY.soTu) loi.push(`Có ${coChu.length} từ khoá — tối đa ${GIOI_HAN_XOAY.soTu}`);
  const thay = new Map<string, number>();
  for (const x of coChu) {
    // MỘT từ khoá giữ luật cũ (≤ 500 ký tự cả tham số — GIOI_HAN_SO_DO.thamSo); từ 2 từ khoá trở lên mỗi từ ≤ 60 ký tự (luật F-1 của Boss)
    const gioiHan = coChu.length > 1 ? GIOI_HAN_XOAY.kyTu : TOI_DA_MOT_TU_KHOA;
    if (dem(x.t) > gioiHan) loi.push(`Dòng ${x.i + 1}: từ khoá dài ${dem(x.t)} ký tự — tối đa ${gioiHan}${coChu.length > 1 ? " khi có nhiều từ khoá" : ""}`);
    if (/"|\{\{/.test(x.t)) loi.push(`Dòng ${x.i + 1}: từ khoá không được chứa dấu nháy kép " hoặc “{{”`);
    const k = khoaSo(x.t);
    const truoc = thay.get(k);
    if (truoc !== undefined) canhBao.push(`Dòng ${x.i + 1} trùng với dòng ${truoc} (“${x.t}”) — dòng trùng sẽ bị bỏ qua khi chạy`);
    else thay.set(k, x.i + 1);
  }
  for (const x of co) {
    const { d, i } = x;
    if (d.soLuong !== null && (!Number.isInteger(d.soLuong) || d.soLuong < SO_LUONG_TOI_THIEU || d.soLuong > SO_LUONG_TOI_DA)) loi.push(`Dòng ${i + 1}: số lượng phải là số nguyên ${SO_LUONG_TOI_THIEU}–${SO_LUONG_TOI_DA}`);
    if (c.cheDo === "gio" && d.chuyenSauGio !== null && (!Number.isInteger(d.chuyenSauGio) || d.chuyenSauGio < GIO_TOI_THIEU || d.chuyenSauGio > GIO_TOI_DA)) loi.push(`Dòng ${i + 1}: số giờ chuyển từ khoá phải là số nguyên ${GIO_TOI_THIEU}–${GIO_TOI_DA}`);
  }
  if (c.cheDo === "gio" && coChu.length > 1) {
    const chuaGio = coChu.filter((x) => x.d.chuyenSauGio === null).length;
    if (chuaGio) canhBao.push(`${chuaGio} dòng chưa ghi số giờ — dùng ${GIO_MAC_DINH} giờ (xoay theo ngày)`);
  }
  const khuyen = tuyChon.soLuongKhuyen ?? null;
  if (khuyen !== null && coChu.length) {
    const sl = coChu.map((x) => x.d.soLuong ?? 0); // dòng chưa ghi số lượng dùng "Số … tối đa" của bước làm việc (không tính ở đây)
    const moiLan = c.cheDo === "tat_ca" ? sl.reduce((a, b) => a + b, 0) : Math.max(0, ...sl);
    if (moiLan > khuyen) canhBao.push(`${c.cheDo === "tat_ca" ? "Tổng" : "Lớn nhất"} ${moiLan} ${tuyChon.donVi ?? "mục"} mỗi lần chạy — khuyên tối đa ${khuyen} để tránh bị hạn chế`);
  }
  return { loi, canhBao };
}

// ---------------------------------------------------------------- chọn từ khoá theo THỜI GIAN ----------------------------------------------------------------
export interface TrangThaiGio { chi: number; moc: number; tu: string; sig: string }
export type LyDoGio = "dau" | "giu" | "het_han" | "doi_danh_sach" | "doi_danh_sach_mat_dong" | "dong_ho_lui";
export interface KetQuaGio { chi: number; tuKhoa: string; moc: number; sig: string; doi: boolean; lyDo: LyDoGio }

/** Chữ ký danh sách (thứ tự + nội dung chuẩn hoá) — đổi danh sách giữa chừng thì chữ ký đổi. */
export const chuKyDanhSach = (ds: readonly string[]): string => ds.map(khoaSo).join("\u0001");

/**
 * CHỌN dòng cho lần chạy theo THỜI GIAN (không gắn nửa đêm): `tt` = trạng thái đã lưu (null = chưa dùng bao giờ). Luật:
 *  · chưa có trạng thái → dòng 1, mốc = bây giờ;
 *  · còn hạn (bây giờ − mốc < giờ của dòng hiện tại) → dùng tiếp dòng hiện tại, mốc giữ nguyên; HẾT HẠN (≥, đúng bằng N giờ là hết) → sang dòng KẾ (hết danh sách → dòng 1), mốc = bây giờ.
 *    Nghỉ nhiều ngày cũng chỉ tiến ĐÚNG MỘT dòng mỗi lần chạy (không nhảy qua nhiều từ khoá, không bỏ sót từ khoá nào);
 *  · đồng hồ chỉnh lùi (bây giờ < mốc) → coi như chưa hết hạn; mốc kéo về bây giờ (không kẹt chờ tới "tương lai");
 *  · danh sách đổi giữa chừng (chữ ký khác): từ khoá đang dùng VẪN CÒN trong danh sách mới → giữ nó (đổi chỗ / thêm / xoá dòng khác không làm mất chỗ đang dùng; giữ mốc);
 *    đã bị xoá / sửa chữ → bắt đầu lại từ dòng 1, mốc = bây giờ.
 *  · giờ của dòng: ô trống / ngoài 1–720 → 24 giờ.
 */
export function chonTheoGio(tt: TrangThaiGio | null, ds: readonly string[], gio: readonly (number | null | undefined)[], bayGio: number): KetQuaGio {
  const n = ds.length;
  const sig = chuKyDanhSach(ds);
  const ket = (chi: number, moc: number, doi: boolean, lyDo: LyDoGio): KetQuaGio => ({ chi, tuKhoa: ds[chi] ?? "", moc, sig, doi, lyDo });
  if (n === 0) return ket(0, bayGio, false, "dau");
  const gioCua = (i: number): number => { const g = gio[i]; return typeof g === "number" && Number.isInteger(g) && g >= GIO_TOI_THIEU && g <= GIO_TOI_DA ? g : GIO_MAC_DINH; };
  if (!tt || !Number.isFinite(tt.moc) || !Number.isInteger(tt.chi)) return ket(0, bayGio, true, "dau");
  let chi = tt.chi, moc = tt.moc, lyDo: LyDoGio = "giu";
  if (tt.sig !== sig) {
    const k = ds.findIndex((x) => khoaSo(x) === khoaSo(tt.tu));
    if (k < 0) return ket(0, bayGio, true, "doi_danh_sach_mat_dong");
    chi = k; lyDo = "doi_danh_sach";
  }
  if (chi < 0 || chi >= n) return ket(0, bayGio, true, "doi_danh_sach_mat_dong");
  if (bayGio < moc) return ket(chi, bayGio, false, "dong_ho_lui");
  if (n > 1 && bayGio - moc >= gioCua(chi) * 3_600_000) return ket((chi + 1) % n, bayGio, true, "het_han");
  return ket(chi, moc, tt.sig !== sig, lyDo);
}

/** Mô tả TĨNH cho trình soạn: bot chưa chạy lần nào thì bắt đầu ở dòng 1. */
export function moTaXoayTinh(c: CauHinhTuKhoa): string {
  const ds = c.dong.filter((d) => d.tuKhoa.trim());
  if (!ds.length) return "";
  if (ds.length === 1) return `Chỉ có một từ khoá “${ds[0]!.tuKhoa}” — lần nào cũng dùng từ khoá này${ds[0]!.soLuong ? `, làm ${ds[0]!.soLuong} mục` : ""}.`;
  if (c.cheDo === "tat_ca") return `Mỗi lần chạy lần lượt dùng cả ${ds.length} từ khoá: ${ds.map((d) => `“${d.tuKhoa}”${d.soLuong ? ` × ${d.soLuong}` : ""}`).join(", ")}.`;
  if (c.cheDo === "lan") return `Mỗi lần chạy dùng một từ khoá theo thứ tự: “${ds[0]!.tuKhoa}”, rồi “${ds[1]!.tuKhoa}”${ds.length > 2 ? "…" : ""}; hết danh sách quay lại dòng 1.`;
  const g = ds[0]!.chuyenSauGio ?? GIO_MAC_DINH;
  return `Chạy lần đầu dùng: “${ds[0]!.tuKhoa}” · đổi sang “${ds[1]!.tuKhoa}” sau ${g} giờ (tính từ lần đầu dùng từ khoá đó; nếu bot nghỉ lâu thì lần chạy kế tiếp mới chuyển).`;
}
